const styles = () => ({
  '.dn-buttons': {
    paddingTop: '20px',
    borderTop: '1px solid #E2E4E9',
    'button + button': {
      marginLeft: '10px',
    },
  },

  '.MuiDialogContent-root': {
    margin: '30px',
    border: '1px solid #E2E4E9',
    borderRadius: '16px',
    boxShadow: '0px 1px 2px 0px #E4E5E73D',
  },
});

export default styles;
